<div class="generic-modal-root">
  
    <div class="row-padding">
      <div class="row" style="width: 100%;">
        <form
          *ngIf="form"
          [formGroup]="form"
          class="m-form m-form--fit m-form--label-align-right"
          style="width: 100%;"
        >
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label"> Subscriber Name </label>
            <div class="col-lg-8" style="display: flex">
              <input
                type="text"
                class="form-control m-input"
                formControlName="fullName"
              />
            </div>
          </div>
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label"> Phone </label>
            <div class="col-lg-8" style="display: flex">
              <input
                type="text"
                class="form-control m-input"
                formControlName="phone"
              />
            </div>
          </div>
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label"> Email </label>
            <div class="col-lg-8" style="display: flex">
              <input
                type="text"
                class="form-control m-input"
                formControlName="email"
              />
            </div>
          </div>
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label"> Campaigns currently pledging </label>
            <div style="display: flex; flex-direction: column; width: 400px; padding-top: 0.65rem;">
                <div *ngFor="let sub of currentSubscriptions; let i = index;" class="col-lg-12" style="display: flex; flex: auto;">
                    {{i + 1 + '. '}} {{ sub.pledgePerWin.event.name }}: {{ sub.pledgePerWinPricingTier.price / 100 | currency }} per {{ sub.pledgePerWin.statistic }}
                </div>
            </div>
          </div>
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label"> Total Amount Pledged </label>
            <div class="col-lg-8" style="display: flex">
                <input
                type="text"
                class="form-control m-input"
                formControlName="totalAmountPledged"
                />
              <img src="../../assets/app/media/img/icons/info-icon.png" class="tooltip-icon" placement="top" style="top: 8px; position: relative;" tooltip="The total amount this subscriber has pledged for all Campaigns they've participated in.">
            </div>
          </div>
  
          <div style="height: 45px;">
            <button
              (click)="close()"
              class="btn btn-success"
              style="margin:10px; float:right"
            >
              Close
            </button>
          </div>
        </form>
      </div>
    </div>
</div>